<template>
  <div>
    <div class="row row-inside">
      <div class="flex md12 mx-2">
        <va-button
          color="primary"
          icon="fa fa-plus"
          @click="createNewFormateur()"
        >
          Nouveau formateur
        </va-button>
      </div>
      <div class="flex md12 mx-2">
        <va-data-table
          class="va-table--hoverable va-table--stripped"
          :fields="fields"
          :data="listeFormateurs"
          no-data-label="Aucun model de formation trouvé"
          :per-page="parseInt(perPage)"
        >
          <template #actions="{ rowData }">
            <va-button
              icon="fa fa-edit"
              color="info"
              @click.stop="openFormateur(rowData)"
            />
            <va-button
              icon="fa fa-trash"
              color="danger"
              @click.stop="deleteFormateur(rowData)"
            />
          </template>
        </va-data-table>
      </div>
    </div>
    <va-modal
      v-model="showDeleteModal"
      title="Supprimer le formateur"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="400px"
      v-on:ok="confirmDeleteFormateur"
      v-on:cancel="showDeleteModal = false"
    >
      <div class="modal-content">
        <h3>Supprimer le formateur</h3>
        <p>Êtes-vous sûr de vouloir supprimer ce formateur ?</p>
      </div>
    </va-modal>

    <create-formateur
      v-model="showCreation"
      :idformation_formateurs="idformation_formateurs"
      @update="getListFormateurs"
      @create="getListFormateurs"
    />
  </div>
</template>

<script>
import axios from "axios";
import CreateFormateur from "./create-formateur.vue";

export default {
  components: {
    "create-formateur": CreateFormateur,
  },
  data() {
    return {
      perPage: 10,
      listeFormateurs: [],
      showDeleteModal: false,
      formateurToDelete: null,
      showCreation: false,
      idformation_formateurs: null,
    }
  },
  mounted() {
    this.getListFormateurs();
  },
  methods: {
    createNewFormateur() {
      this.idformation_formateurs = null;
      this.showCreation = true;
    },
    async deleteFormateur(formateur) {
      this.formateurToDelete = formateur;
      this.showDeleteModal = true;
    },
    async confirmDeleteFormateur() {
      try {
        await axios.delete("/api/afpf/delete-formateur", {
          params: { idformation_formateurs: this.formateurToDelete.idformation_formateurs }
        });
        this.launchEpicmaxToast("Formateur supprimé avec succès");
        this.getListFormateurs();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.launchEpicmaxToast("Ce formateur est utilisé par une ou plusieurs formations et ne peut pas être supprimé.");
        } else {
          console.error(error);
          this.launchEpicmaxToast("Erreur lors de la suppression du formateur");
        }

      } finally {
        this.showDeleteModal = false;
        this.formateurToDelete = null;
      }
    },
    openFormateur(formateur) {
      this.idformation_formateurs = formateur.idformation_formateurs;
      this.showCreation = true;
    },

    async getListFormateurs() {
      try {
        let results = await axios.get("/api/afpf/liste-formateurs");
        this.listeFormateurs = results.data;
        this.idformation_formateurs = null;
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la récupération de la liste des modèles de formation");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    fields() {
      return [
        {
          name: "titre",
          title: "Titre",
          sortField: "titre"
        },
        {
          name: "prenom",
          title: "Prénom",
          sortField: "prenom"
        },
        {
          name: "nom",
          title: "Nom",
          sortField: "nom"
        },
        {
          name: "__slot:actions",
          title: "Actions",
        },
      ]
    },
  },
}
</script>

<style>
</style>